module.exports = __webpack_public_path__ + "img/fashion_28.8a3163f5.jpg";